import React from "react";
import "../Styles/_OrderCancelledInformation.css";
import { Confirmed } from "./_Icon";
import { orderUtils } from "../Helpers/OderUtils";
import moment  from "moment";

const OrderCancelledInformation = ({ currentLanguage, order }) => {
    return (
        orderUtils.orderIsCancelled(order) && <div className="cancelled-container">
            <div className="cancelled-container-label">
                <Confirmed fill="#BF0000" />
                <p>{`${currentLanguage.ORDER_PAGE.CANCELLED_SECTION.CANCELLED_MESSAGE} `}{moment(new Date(order.cancelled_at)).format("LL")}</p>                
            </div>
        </div>
    );
};

export default OrderCancelledInformation;



// WEBPACK FOOTER //
// ./src/views/Order/components/_OrderCancelledInformation.jsx